import axios from 'axios';
import { isSessionAuthFailure as detectSessionAuthFailure, shouldSkipSessionRecovery } from './sessionAuth';

let sessionRecoveryInProgress = false;

export function isLocalDevHost() {
  const host = window.location.hostname;
  return host === 'localhost' || host === '127.0.0.1';
}

/**
 * On a local dev host the API is http://localhost:5100 unless
 * REACT_APP_API_URL names another local backend (a second dev pair on other
 * ports, e.g. 3103 → 5102). A production URL baked into a build is ignored on
 * localhost so a locally served build never talks to production by accident.
 */
export function getApiBaseUrl() {
  const configured = String(process.env.REACT_APP_API_URL || '').trim().replace(/\/+$/, '');
  if (isLocalDevHost()) {
    return /^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?$/i.test(configured) ? configured : 'http://localhost:5100';
  }
  return configured;
}

export function isSessionAuthFailure(error) {
  return detectSessionAuthFailure(error, getApiBaseUrl());
}

export { shouldSkipSessionRecovery } from './sessionAuth';

export async function recoverSession(reason) {
  if (sessionRecoveryInProgress || isLocalDevHost()) return;
  sessionRecoveryInProgress = true;
  console.warn('[Session] Reloading to recover session:', reason);

  try {
    await axios.post(`${getApiBaseUrl()}/api/auth/logout`, {}, { withCredentials: true });
  } catch (_) {
    // Best-effort cookie clear before reload.
  }

  window.location.reload();
}

export function setupAxiosInterceptors() {
  axios.defaults.withCredentials = true;

  // Lazy-required so importing apiClient (tests, utilities) never drags the
  // health tracker's timers in — only the real app wires it via setup.
  const { reportApiError, reportApiSuccess } = require('./backendHealth');

  axios.interceptors.response.use(
    (response) => {
      reportApiSuccess(response);
      return response;
    },
    (error) => {
      reportApiError(error);
      if (isSessionAuthFailure(error) && !shouldSkipSessionRecovery(error)) {
        recoverSession(error.response?.data?.error || '401');
      }
      return Promise.reject(error);
    }
  );
}
